exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width: 992px) {\n    .content-wrapper {\n        display: block;\n        position: absolute;\n        height: 88%;\n        bottom: 0;\n        top: 0;\n        left: 0;\n        right: 0;\n        margin-top: 78px;\n        margin-left: 250px;\n        overflow-y: auto;\n        overflow-x: hidden;\n    }\n}\n\n.content-wrapper {\n    padding: 20px;\n}\n\n:host >>> .content-wrapper {\n    background: transparent;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 743
// module chunks = 0